import {
    createFromIconfontCN
} from '@ant-design/icons';


const CsIcon = createFromIconfontCN({
    scriptUrl: '//at.alicdn.com/t/font_3325953_vhwq12a3dfn.js', // 在 iconfont.cn 上生成
});

export default CsIcon;
